import React from "react";
import DocumentType from "./DocumentType";
import Zapisnice from "../misc/Zapisnice";
import Sprints from "../misc/Sprints";
import Exports from "../misc/Exports";
import Methods from "../misc/Methods";
import Other from "../misc/Other";

function Documents() {
  return (
    <div id="docu" className="mt-5">
      <hr
        style={{
          color: "#0b032d",
          backgroundColor: "#0b032d",
          height: 1,
          opacity: "50%",
        }}
      />
      <h1>Pracovné dokumenty</h1>
      <DocumentType name="Zápisnice" data={Zapisnice} class></DocumentType>
      <DocumentType name="Zhodnotenie šprintov" data={Sprints}></DocumentType>
      <DocumentType name="Exporty úloh" data={Exports}></DocumentType>
      <DocumentType name="Metodiky" data={Methods}></DocumentType>
      <DocumentType name="Ostatné dokumenty" data={Other}></DocumentType>
    </div>
  );
}

export default Documents;
